export enum ProjectFileUpdateAction {
  Add = 'add',
  Remove = 'remove'
}
